import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {Alerts} from '../models/alerts.model';
import * as moment from 'moment';
import {AlertStatus} from '../utility/alerts.enum';
import {timeFormat} from '../utility/time-format';
import {SystemStoreFacadeService} from '@drl/core/store/system-store-facade.service';

@Injectable()
export class AlertsAdapter implements IAdapter<Alerts> {
  constructor(private readonly systemStoreFacade: SystemStoreFacadeService) {}
  adaptToModel(resp: any): Alerts {
    this.systemStoreFacade
      .getLocale()
      .subscribe(locale => moment.locale(locale));
    const alert: Alerts = {...resp};

    const highPriority = 1,
      mediumPriority = 2,
      lowPriority = 3;

    // create severity text from severity levels

    //extract time of creation from createOn
    if (alert.createdOn) {
      alert.timeOfCreation = moment(alert.createdOn).format(timeFormat);
    }

    alert.bgndClass = 'mr-2 add-wrap';

    if (
      alert.priority === highPriority &&
      alert.status === AlertStatus.Active
    ) {
      alert.cssClass = 'fas fa-circle active alert-o';
    } else if (
      alert.priority === highPriority &&
      alert.status === AlertStatus.Resolved
    ) {
      alert.cssClass = 'fas fa-check-circle alert-o';
    } else if (
      alert.priority === lowPriority &&
      alert.status === AlertStatus.Active
    ) {
      alert.cssClass = 'fas fa-circle alert-dy';
    } else if (
      alert.priority === lowPriority &&
      alert.status === AlertStatus.Resolved
    ) {
      alert.cssClass = 'fas fa-check-circle alert-dy';
    } else if (
      alert.priority === mediumPriority &&
      alert.status === AlertStatus.Active
    ) {
      alert.cssClass = 'fas fa-circle alert-lo';
    } else if (
      alert.priority === mediumPriority &&
      alert.status === AlertStatus.Resolved
    ) {
      alert.cssClass = 'fas fa-check-circle alert-lo';
    } else {
      // Do nothing
    }

    alert.timeElapsed = moment(alert.createdOn).fromNow();

    return alert;
  }
  adaptFromModel(data: Alerts): any {
    return data;
  }
}
